import React from 'react';
import { Send, X } from 'lucide-react';

interface CommentBoxProps {
    value: string;
    placeholder?: string;
    onChange: (newValue: string) => void;
    onSubmit: () => void;
    onCancel: () => void;
}

const CommentBox: React.FC<CommentBoxProps> = ({
    value,
    placeholder = 'Add a comment...',
    onChange,
    onSubmit,
    onCancel,
}) => {
    const isEmpty = !value.trim();

    return (
        <div className="mt-3">
            <div className="relative bg-gray-100 rounded-lg p-2">
                <div className="mb-3">
                    <textarea
                        className="p-1 w-full bg-gray-100 text-gray-500 resize-none focus:outline-none placeholder-gray-500 min-h-[70px]"
                        placeholder={placeholder}
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                    />
                </div>
                <div className="absolute bottom-0 right-4 flex items-center gap-2 bg-transparent p-1">
                    <button
                        onClick={onCancel}
                        className="p-1 hover:bg-gray-700 rounded-full transition-colors"
                    >
                        <X size={18} className="text-gray-400" />
                    </button>
                    <button
                        onClick={onSubmit}
                        className="p-1 hover:bg-gray-700 rounded-full transition-colors"
                        disabled={isEmpty}
                    >
                        <Send size={18} className={isEmpty ? 'text-gray-400' : 'text-blue-400'} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CommentBox;
